<template>
    <md-layout md-gutter class="bg-register register-doctor register--wrap" v-if="lang">
        <div class="container">
            <div class="logo col-sm-6" style="padding-top: 20px;">
                <!-- <router-link :to="{ name:'login.doctor' }"><img class="register-logo" src="../../assets/img/logo.png" width="250"></router-link> -->
            </div>
            <div class="clearfix"></div>
            <br/>
            <div class="mt-panel register-panel">
                <div class="col-sm-6" style="overflow:hidden;">
                    <h3 class="md-title color--title section--title">
                        {{ translate.pages.register.subtitle }}
                        <span class="badge badge-title">{{ translate.pages.register.description }}</span> </h3>
                </div>
                <!-- TODO: Update Language -->
                <div class="row container language--box language--register">
                    <md-layout md-gutter md-align="end">
                        <span class="language"><md-icon>language</md-icon></span>
                        <md-select v-model="lang" @change="updateLang">
                            <md-option :value="language.code" v-for="language in languages" :key="language.id">{{ language.name }}</md-option>
                        </md-select>
                    </md-layout>
                </div>
                <md-layout md-flex="100">
                    <div class="register-steps">
                        <div :class="['col-xs-6', 'mt-tab', { 'mt-tab-active': data.activeTab === 0 }]">
                            <span class="badge circle">1</span> <span>{{ translate.pages.register.tabs.personal_information }}</span>
                        </div>
                        <div :class="['col-xs-6', 'mt-tab', { 'mt-tab-active': data.activeTab === 1 }]">
                            <span class="badge circle">2</span> <span>{{ translate.pages.register.tabs.confirmation }}</span>
                        </div>
                    </div>

                    <div v-show="data.activeTab === 0" class="col-sm-12 register-first-step">
                        <div v-if="update_massive">
                            <span class="text-center" style="color: #76be33;">
                                <p style="color: white;background: rgb(33, 150, 243);padding: 10px;border-radius: 3px;">Por favor, complete sus datos</p>
                            </span>
                        </div>
                        <form novalidate @submit.prevent="submit('form-doctor')" data-vv-scope="form-doctor">
                            <div class="row">
                                <div class="col-sm-12" style="text-align:center">
                                    <md-switch md-theme="green" class="md-primary" v-model="doctor.is_institution">{{ translate.pages.register.fields.is_institution }}</md-switch>
                                </div>
                                <div class="col-sm-6">
                                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('email') }">
                                        <label>{{ translate.pages.register.fields.code }}</label>
                                        <md-input
                                            v-model="doctor.code"
                                            @change="changeCode"
                                            required></md-input>
                                        <span class="md-error" v-if="errors.code">{{ errors.code }}</span>
                                         <div class="marcaagua">ej: 1234567-8</div>
                                    </md-input-container>

                                </div>
                                <div class="col-sm-6">
                                    <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-doctor.name') }">
                                        <label>{{ translate.pages.register.fields.name }}</label>
                                        <md-input
                                            v-model="doctor.name"
                                            v-validate
                                            data-vv-name="name"
                                            data-vv-rules="required|min:1"
                                            required></md-input>
                                            <div class="marcaagua">ej: SERVICIO MEDICO DENTAL</div>
                                        <span class="md-error">{{ _errors.first('form-doctor.name') }}</span>
                                    </md-input-container>
                                </div>
                                <div class="col-sm-6" v-if="!doctor.is_institution">
                                    <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-doctor.lastname') }">
                                        <label>{{ translate.pages.register.fields.lastname }}</label>
                                        <md-input
                                            v-model="doctor.lastname"
                                            v-validate
                                            data-vv-name="lastname"
                                            data-vv-rules="alpha_spaces|min:1"
                                            ></md-input>
                                        <span class="md-error">{{ _errors.first('form-doctor.lastname') }}</span>
                                    </md-input-container>
                                </div>
                                <div class="col-sm-6" v-if="!doctor.is_institution">
                                    <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-doctor.lastname2') }">
                                        <label>{{ translate.pages.register.fields.lastname2 }}</label>
                                        <md-input
                                            v-model="doctor.lastname2"
                                            v-validate
                                            data-vv-name="lastname2"
                                            data-vv-rules="alpha_spaces|min:1"
                                            ></md-input>
                                        <span class="md-error">{{ _errors.first('form-doctor.lastname2') }}</span>
                                    </md-input-container>
                                </div>
                                <div class="col-sm-6">
                                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('email') }">
                                        <label>{{ translate.pages.register.fields.email }} </label>
                                        <md-input v-model="doctor.email" @change="changeEmail()" required ></md-input>
                                        <div class="marcaagua">ej: correo@correo.cl</div>
                                        <span class="md-error" v-if="errors.email">{{ errors.email }}</span>
                                    </md-input-container>
                                </div>
                                <div class="col-sm-6">
                                    <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-doctor.phone') }">
                                        <label>{{ translate.pages.register.fields.phone }}</label>
                                        <md-input

                                            v-model="doctor.phone"
                                            v-validate
                                            data-vv-name="phone"
                                            data-vv-rules="required|numeric|min:6|max:12"
                                            required
                                           ></md-input>
                                           <div class="marcaagua" data-v-44c3599e="">ej: 9999999</div>
                                        <span class="md-error">{{ _errors.first('form-doctor.phone') }}</span>
                                    </md-input-container>
                                </div>
                                <div class="col-sm-6">
                                    <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-doctor.password') }">
                                        <label>{{ translate.pages.register.fields.password }}</label>
                                        <md-input type="password"
                                            v-model="doctor.password"
                                            autocomplete="new-password"
                                            v-validate
                                            data-vv-name="password"
                                            data-vv-rules="required|min:6"
                                            required
                                            ref="password"
                                            ></md-input>
                                        <span class="md-error">{{ _errors.first('form-doctor.password') }}</span>
                                    </md-input-container>
                                </div>
                                <div class="col-sm-6">
                                    <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-doctor.password_confirmation') }">
                                        <label>{{ translate.pages.register.fields.password_confirmation}}</label>
                                        <md-input type="password"
                                            v-model="doctor.password_confirmation"
                                            v-validate
                                            data-vv-name="password_confirmation"
                                            data-vv-as="Confirmar Contraseña"
                                            data-vv-rules="required|min:6|confirmed:password"
                                            required
                                            ></md-input>
                                            <!--Se valida el mensaje usando v-if y asi comparar de forma exacta la contraseña-->
                                        <span class="md-error" v-if="doctor.password != doctor.password_confirmation" >{{ _errors.first('form-doctor.password_confirmation') }}</span>
                                    </md-input-container>
                                </div>
                                <div class="col-sm-12 mar-top-2 mt-table-bordered">
                                    <div class="row">
                                        <div class="col-sm-12">
                                             <label class="subtitle">Seleccionar Tipo</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <md-checkbox id="medicina_checkbox_1" md-theme="green" class="md-primary" name="medicina_checkbox_1" v-model="doctor.medicina_checkbox_1">Medicina</md-checkbox>
                                        </div>
                                        <div class="col-sm-4">
                                            <md-checkbox id="medicina_checkbox_2" md-theme="green" class="md-primary" name="medicina_checkbox_2" v-model="doctor.medicina_checkbox_2">Profesionales Auxiliares de la Medicina</md-checkbox>
                                        </div>
                                        <div class="col-sm-4">
                                            <md-checkbox id="medicina_checkbox_3" md-theme="green" class="md-primary" name="medicina_checkbox_3" v-model="doctor.medicina_checkbox_3">Especialidades Odontológicas</md-checkbox>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <md-checkbox id="medicina_checkbox_4" md-theme="green" class="md-primary" name="medicina_checkbox_4" v-model="doctor.medicina_checkbox_4">Imagenología</md-checkbox>
                                        </div>
                                        <div class="col-sm-4">
                                            <md-checkbox id="medicina_checkbox_5" md-theme="green" class="md-primary" name="medicina_checkbox_5" v-model="doctor.medicina_checkbox_5">Medicina Tradicional y Complementaria</md-checkbox>
                                        </div>
                                        <div class="col-sm-4">
                                            <md-checkbox id="medicina_checkbox_6" md-theme="green" class="md-primary" name="medicina_checkbox_6" v-model="doctor.medicina_checkbox_6">Tratamientos</md-checkbox>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-sm-12 mar-top-2">
                                    <md-input-container style="margin: 0 !important;">
                                        <md-input type="text" v-model="filterSpecialities" placeholder="Buscar Especialidad..."></md-input>
                                    </md-input-container>
                                    <div class="multiple checkbox-list">
                                        <p class="title">{{ translate.pages.register.fields.specialities }}</p>

                                        <div class="select">

                                            <md-checkbox class="option" v-for="speciality in filteredSpecialities" :key="speciality.id" @change="onChosen($event,speciality.id)" v-model="speciality.checked">{{ speciality.name }}</md-checkbox>
                                        </div>
                                    </div>
                                    <label class="subtitle" :class="{ error: errors.specialities }">
                                        {{ translate.pages.register.fields.selects_specialties }}
                                    </label>
                                </div>
                                <div class="col-sm-8 mar-top-2 checkbox-list">
                                    <div>
                                        <md-checkbox id="notification_appointment" md-theme="green" class="md-primary" name="notification_appointment" v-model="doctor.notification_appointment">{{ translate.pages.register.fields.appointments }}</md-checkbox>
                                    </div>
                                    <div >
                                        <md-checkbox id="notification_mail" md-theme="green" class="md-primary" name="notification_mail" v-model="doctor.notification_mail">{{ translate.pages.register.fields.notification }}</md-checkbox>
                                    </div>

                                    <!-- // OCULTADO POR MAURICIO MARCHANT A PETICIÓN DE SERGIO BUSTAMANTE EL 25 DE SEPT DE 2020 -->
                                    <div >
                                        <md-checkbox id="need_box" md-theme="green" class="md-primary" name="need_box" v-model="doctor.need_box">Necesito un BOX</md-checkbox>
                                    </div>


                                </div>
                                <div class="bonus_container medibox" v-if="doctor.need_box" style="
                                    width: 100%;
                                    float: left;
                                    background: rgba(234, 234, 234, 0.46);">
                                    <div class="alert alert-info" style="
                                        background: #00bcd4;
                                        color: white;
                                        padding: 10px;
                                        border-radius: 10px;">MediBox</div>
                                    <div style="padding: 10px">
                                        <md-layout md-gutter>

                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b style="    display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;"> Indique donde prefiere el Box</b>
                                            </md-layout>

                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b>Provincia</b>
                                            </md-layout>

                                            <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' : data.region.label =='' }" style="margin-top: 5px !important;margin-bottom: 27px;">
                                                <vue-select
                                                    :options="regions"
                                                    placeholder="Provincia"
                                                    v-validate
                                                    required
                                                    data-vv-name="region"
                                                    :on-change="changeRegion"
                                                    v-model="data.region.label"
                                                    class="md-input select2"
                                                    style="width: 100%;"
                                                    >
                                                    <span slot="no-options">No se encontraron resultados.</span>
                                                </vue-select>
                                                <span class="md-error">Provincia es requerido</span>
                                            </md-layout>

                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b>Comuna</b>
                                            </md-layout>

                                            <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' : data.city.label =='' }" style="margin-top: 5px !important; margin-bottom: 27px;">
                                                <vue-select
                                                    :options="comunities"
                                                    placeholder="Comuna"
                                                    v-validate
                                                    required
                                                    data-vv-name="city"
                                                    :on-change="changeCity"
                                                    v-model="data.city.label"
                                                    style="width: 100%;"
                                                    class="md-input select2"
                                                    :disabled="data.region.value == '0'"
                                                    >
                                                    <span slot="no-options">No se encontraron resultados.</span>
                                                </vue-select>
                                                <span class="md-error">Comuna es requerido</span>
                                            </md-layout>

                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b style="display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;">
                                                    Indique el periodo de arriendo que desea
                                                </b>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' :data.box_plan.label =='' }" style="margin-top: 5px !important;margin-bottom: 27px;">
                                                <vue-select
                                                    :options="box_plans"
                                                    v-validate
                                                    required
                                                    data-vv-name="box_plan"
                                                    placeholder="Periodo de Arriendo"
                                                    v-model="data.box_plan.label"
                                                    class="md-input select2"
                                                    style="width: 100%;"
                                                    >
                                                    <span slot="no-options">No se encontraron resultados.</span>
                                                </vue-select>
                                                <span class="md-error">Periodo de arriendo es requerido</span>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b style="display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;">
                                                    Indique Especialidad, Horarios y Precio
                                                </b>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b>Especialidad</b>
                                            </md-layout>

                                            <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' : data.specialty.label =='' }" style="margin-top: 5px !important;margin-bottom: 27px;">
                                                <vue-select
                                                    :options="filteredSpecialities"
                                                    placeholder="Especialidad"
                                                    v-validate
                                                    required
                                                    data-vv-name="box_spe"
                                                    :on-change="changeSpecialty"
                                                    v-model="data.specialty.label"
                                                    class="md-input select2"
                                                    style="width: 100%;"
                                                    >
                                                    <span slot="no-options">No se encontraron resultados.</span>
                                                </vue-select>
                                                <span class="md-error">Especialidad es requerido</span>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b>Precio</b>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" :class="{ 'md-input-invalid' : data.specialty.label =='' }" style="margin-top: 5px !important;margin-bottom: 27px;">
                                                <div class="col-sm-6">
                                                    <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-doctor.price') }">
                                                        <label> Precio </label>
                                                        <md-input
                                                            v-model="data.price"
                                                            v-validate
                                                            data-vv-name="price"
                                                            data-vv-rules="required|numeric"
                                                            required
                                                        ></md-input>
                                                        <div class="marcaagua" data-v-44c3599e="">ej: 9999999</div>
                                                        <span class="md-error">{{ _errors.first('form-doctor.price') }}</span>
                                                    </md-input-container>
                                                </div>
                                                <br>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b>   Horario Mañana</b>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px !important;">
                                                <ul class="schedule_days">
                                                    <li>
                                                        <md-checkbox v-model="radio1" id="my-test1" name="my-test-group1" md-value="1">Lunes</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio2" id="my-test1" name="my-test-group1" md-value="1">Martes</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio3" id="my-test1" name="my-test-group1" md-value="1">Miercoles</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio4" id="my-test1" name="my-test-group1" md-value="1">Jueves</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio5" id="my-test1" name="my-test-group1" md-value="1">Viernes</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio6" id="my-test1" name="my-test-group1" md-value="1">Sabado</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio7" id="my-test1" name="my-test-group1" md-value="1">Domingo</md-checkbox>
                                                    </li>
                                                </ul>
                                                <md-button type="button"  class="md-raised pull-right md-size" @click="resetSchedule(1)">
                                                    Reiniciar
                                                </md-button>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100">
                                                <b>   Horario Tarde</b>
                                            </md-layout>
                                            <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px !important;">
                                                <ul class="schedule_days">
                                                    <li>
                                                        <md-checkbox v-model="radio8" id="my-test1" name="my-test-group1" md-value="2">Lunes</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio9" id="my-test1" name="my-test-group1" md-value="2">Martes</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio10" id="my-test1" name="my-test-group1" md-value="2">Miercoles</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio11" id="my-test1" name="my-test-group1" md-value="2">Jueves</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio12" id="my-test1" name="my-test-group1" md-value="2">Viernes</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio13" id="my-test1" name="my-test-group1" md-value="2">Sabado</md-checkbox>
                                                    </li>
                                                    <li>
                                                        <md-checkbox v-model="radio14" id="my-test1" name="my-test-group1" md-value="2">Domingo</md-checkbox>
                                                    </li>
                                                </ul>
                                                <md-button type="button"  class="md-raised pull-right md-size" @click="resetSchedule(2)">
                                                    Reiniciar
                                                </md-button>
                                            </md-layout>

                                        </md-layout>
                                    </div>
                                </div>
                                <div class="bonus_container" v-if="doctor.prefix == 'CL'" style="
                                    background: #eaeaea75;
                                    width: 100%;
                                    float: left;">
                                    <div class="alert alert-info" style=" background: #f34b4b; color: white; padding: 10px; border-radius: 10px;">
                                        Bonificación a Pacientes COLABORAMED
                                    </div>
                                    <div style="width:100%; margin:10px;">
                                        Ingrese el Descuento que ofrece para cada tipo de Paciente
                                    </div>
                                    <div class="bonus_set">
                                        <label for="bon_particular">Particular</label>
                                        <small>Porcentaje de descuento</small>  <br>
                                        <!-- <input type="number" name="bon_particular" id="bon_particular" min="0" max="100" v-model="doctor.bon_particular"> -->
                                        <NumberInputSpinner
                                            :min="0"
                                            :max="100"
                                            :step="1"
                                            :inputClass="'spin_input'"
                                            :buttonClass="'spin_btn'"
                                            :integerOnly="true"
                                            v-model="doctor.bon_particular"/>
                                    </div>
                                    <div class="bonus_set">
                                        <label for="bon_fonasa">FONASA</label>
                                        <small>Porcentaje de descuento de Copago</small>    <br>
                                        <!--<input type="number" name="bon_fonasa" id="bon_fonasa"  min="0" max="100" v-model="doctor.bon_fonasa"> -->
                                        <NumberInputSpinner
                                            :min="0"
                                            :max="100"
                                            :step="1"
                                            :inputClass="'spin_input'"
                                            :buttonClass="'spin_btn'"
                                            :integerOnly="true"
                                            v-model="doctor.bon_fonasa"/>
                                    </div>
                                    <div class="bonus_set">
                                        <label for="bon_isapre">ISAPRE</label>
                                        <small>Porcentaje de descuento de Copago</small>    <br>
                                            <!--<input type="number" name="bon_isapre" id="bon_isapre"  min="0" max="100" v-model="doctor.bon_isapre"> -->
                                        <NumberInputSpinner
                                            :min="0"
                                            :max="100"
                                            :step="1"
                                            :inputClass="'spin_input'"
                                            :buttonClass="'spin_btn'"
                                            :integerOnly="true"
                                            v-model="doctor.bon_isapre"/>
                                    </div>
                                    <div style="width:100%; margin:10px; padding: 15px !important;">
                                        <b>Condiciones específicas:</b>
                                        Me comprometo a cumplir estos descuentos a todos los Pacientes de COLABORAMED por el plazo mínimo de un año,
                                        y mientras esté vigente mi Registro en COLABORAMED.
                                    </div>

                                    <!--<div v-show="(doctor.bon_particular < 25 || doctor.bon_isapre < 25 || doctor.bon_fonasa < 25)" style="clear: both;">
                                        <div class="alert alert-info" style="
                                        background: rgb(213, 88, 90);
                                        color: white;
                                        padding: 10px;
                                    "> Como minimo debes otorgar un 25% de descuento.</div>
                                    </div> -->
                                </div>

                            </div>
                            <div class="row mar-top-1">
                                <div class="col-sm-6">
                                    <p class="md-body-2 form-note"><strong>Importante:</strong> Todos los campos en <span class="color--red">*</span> son requeridos.</p>
                                </div>
                                <div class="col-sm-6">
                                    <md-button type="submit" class="md-raised md-primary pull-right md-size" :disabled="process">
                                        {{ translate.actions.next }} <md-icon style="margin-bottom: 3px">keyboard_arrow_right</md-icon>
                                    </md-button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div v-show="data.activeTab === 1" class="col-sm-12">
                        <br/>
                        <div class="col-sm-12 text-center" v-show="data.confirmation.isSuccess">
                            <img src="../../assets/img/icon-success.png" class="img-responsive center-block" style="width: 100px!important">
                            <span class="md-display-2" style="color: #76be33;">{{ translate.pages.register.message.success.title }} </span>
                            <p class="md-body-2" style="color: #8a9299 !important">{{ translate.pages.register.message.success.description }} <strong>{{ doctor.paid_code }}</strong>.</p>
                            <md-button href="https://tienda.agendaenlinea.cl/" target="_blank" class="md-raised md-size btn--green" style="padding-top 5px; background-color: #76be33; color: #ffffff; margin-bottom:2em;line-height: 46px;">
                                <md-icon>shopping_cart</md-icon> Pagar en Linea
                            </md-button>
                            <!--<md-button @click.native="redirectLogin" class="md-raised md-size btn--gray" style="padding-top 5px; background-color: #f0f0f0 !important; color: #4d5667 !important; margin-bottom:2em;line-height: 46px;">
                                <md-icon>phonelink</md-icon> Oficina Virtual
                            </md-button> -->
                            <md-button href="office" target="_blank" class="md-raised md-size btn--gray" style="padding-top 5px; background-color: #f0f0f0 !important; color: #4d5667 !important; margin-bottom:2em;line-height: 46px;">
                                <md-icon>phonelink</md-icon> Oficina Virtual
                            </md-button>

                        </div>
                        <div class="col-sm-12 text-center" v-show="data.confirmation.isError">
                            <img src="../../assets/img/icon-error.png" class="img-responsive center-block" style="width: 100px!important">
                            <span class="md-display-2" style="color: #f26061;">{{ translate.pages.register.message.error.title }}</span>
                            <p class="md-body-2" style="color: #8a9299 !important">{{ translate.pages.register.message.error.description }}</p>
                        </div>
                    </div>
                </md-layout>
            </div>
            <br/>
        </div>
    </md-layout>
</template>


<script>
const FloatLabel = (() => {

  // add active class and placeholder
  const handleFocus = (e) => {
    const target = e.target;
    target.parentNode.classList.add('active');
    target.setAttribute('placeholder', target.getAttribute('data-placeholder'));
  };

  // remove active class and placeholder
  const handleBlur = (e) => {
    const target = e.target;
    if(!target.value) {
      target.parentNode.classList.remove('active');
    }
    target.removeAttribute('placeholder');
  };

  // register events
  const bindEvents = (element) => {
    const floatField = element.querySelector('input');
    floatField.addEventListener('focus', handleFocus);
    floatField.addEventListener('blur', handleBlur);
  };

  // get DOM elements
  const init = () => {
    const floatContainers = document.querySelectorAll('.float-container');

    floatContainers.forEach((element) => {
      if (element.querySelector('input').value) {
          element.classList.add('active');
      }

      bindEvents(element);
    });
  };

  return {
    init: init
  };
})();

FloatLabel.init();
</script>


<script src="https://unpkg.com/lodash@4.13.1/lodash.min.js"></script>
<script>
    import {mapActions} from 'vuex';
    import { login, doctor, public_api } from '../../config/api.js';
    import {validate_chile} from '../../config/validators.js';
    import NumberInputSpinner from 'vue-number-input-spinner'
    const swal = require('sweetalert2');
    import _ from 'lodash';
    import vueSelect from "vue-select";
    import Form from "vform"
    export default {
        components: {
            NumberInputSpinner,
            vueSelect
        },
        created(){
            if(!this.$store.getters.language.app){
                this.loadLanguage();
            }else{
                this.getSpecialities();
            }
            var country = { "country": this.$route.params.country.toUpperCase() };
            this.$http.post(public_api.api.regions, country).then(response => {
                    let data = response.data.data;
                    data.map((item, index) => {
                        item.value = item.geonameId;
                        item.label = item.toponymName;
                    });
                    // storage regions
                    this.regions = data;
                    //console.log(this.regions)
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        data() {
            return {
                radio1: false,
                radio2: false,
                radio3: false,
                radio4: false,
                radio5: false,
                radio6: false,
                radio7: false,
                radio8: false,
                radio9: false,
                radio10: false,
                radio11: false,
                radio12: false,
                radio13: false,
                radio14: false,
                regions: [],
                hours: [
                    {label: "Mañana", value: 0},
                    {label: "Tarde", value: 1}
                ],
                box_plans: [
                    {label: "Mensual: AM y PM", value: 'monthly_full'},
                    {label: "Mensual: 1/2 día AM o PM", value: 'monthly_partial'}
                ],
                comunities: [],
                filterSpecialities: "",
                process: false,
                update_massive: false,
                doctor : {
                    medicina_checkbox_1: false,
                    medicina_checkbox_2: false,
                    medicina_checkbox_3: false,
                    medicina_checkbox_4: false,
                    medicina_checkbox_5: false,
                    medicina_checkbox_6: false,
                    need_box: false,
                    code : '',
                    name : '',
                    lastname : '',
                    lastname2 : '',
                    email : '',
                    phone : '',
                    password : '',
                    password_confirmation : '',
                    notification_appointment : false,
                    notification_mail : false,
                    is_institution: false,
                    paid_code: '',
                    type: 'doctor',
                    specialities: [],
                    prefix: this.$route.params.country.toUpperCase(),
                    register_source: '',
                    bon_particular: 45,
                    bon_fonasa: 50,
                    bon_isapre: 50,
                    box_data: {

                    }
                },
                specialities: [],
                data: {
                    'region_id': null,
                    'region': { label: null, value: null },
                    'comunity_id': null,
                    'city': { label: null, value: null },
                    'specialty_id': null,
                    'specialty': { label: null, value: null },
                    'hour_type': 0,
                    'hour': { label: null, value: null },
                    'box_plan': { label: null, value: null },
                    'price': null,


                    confirmation : {
                        isSuccess : false,
                        isError : false,
                    },
                    activeTab : 0,
                },
                errors: {
                    code                  : "",
                    email                 : "",
                    specialities: ''
                },
                route: {
                    doctor: doctor,
                }
            }
        },
        computed: {
            filteredSpecialities(){
                let self = this;

                return this.specialities.filter(specialty => {
                    if (this.doctor.medicina_checkbox_1 && specialty.medicine_type == 1 && specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0){
                        return true;
                    }
                    if (this.doctor.medicina_checkbox_2 && specialty.medicine_type == 2 && specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0){
                        return true;
                    }
                    if (this.doctor.medicina_checkbox_3 && specialty.medicine_type == 3 && specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0){
                        return true;
                    }
                    if (this.doctor.medicina_checkbox_4 && specialty.medicine_type == 4 && specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0){
                        return true;
                    }
                    if (this.doctor.medicina_checkbox_5 && specialty.medicine_type == 5 && specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0){
                        return true;
                    }
                    if (this.doctor.medicina_checkbox_6 && specialty.medicine_type == 6 && specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0){
                        return true;
                    }


                    if (!this.doctor.medicina_checkbox_1 && !this.doctor.medicina_checkbox_2 && !this.doctor.medicina_checkbox_3 && !this.doctor.medicina_checkbox_4 && !this.doctor.medicina_checkbox_5 && !this.doctor.medicina_checkbox_6)
                       return specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0;
                })
            },
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            },
            // Get Languages
            languages() {
                return this.$store.getters.language.languages;
            },
             register_source(){
                var link;
                try{
                    if(top.location.href) {
                        link = 'plat'
                    }
                }catch (e){
                    link = 'redsalud'
                }
                if((this.$route.params.source && this.$route.params.source.length >= 3)){
                    link = 'redsalud'
                    console.log("es redsalud")
                }
                return link
            }
        },
        watch: {
            code: function (){
                this.changeCode();
            },
            email: function (){
                this.changeEmail();
            },
            lang(val) {
                if(val){
                    this.getSpecialities();
                }
            },
            register_source: function(val){
                console.log(val)
            }
        },
        methods: {

            resetSchedule(zone){
                if(zone == 1){
                    for (var index = 0; index < 8; index++) {
                            this["radio"+index] = null;
                    }
                } else {
                    for (var index = 8; index < 15; index++) {
                            this["radio"+index] = null;
                    }
                }
            },
             changeRegion(value){
                if(value){
                    let region = this.regions.find(item => {
                        return item.geonameId == value.geonameId})
                    if(region){
                        this.data.region.label = region.label
                        this.data.region.value = region.value
                        this.$http.post(public_api.api.cities, {region: this.data.region.value})
                            .then(response => {
                                let data = response.data.data
                                data.map(item => {
                                    item.value = item.geonameId
                                    item.label = item.toponymName
                                })
                                this.comunities = data
                                this.data.city.label = ''
                                this.data.city.value = ''
                            })
                    }
                }else{
                    this.comunities = []
                }
            },
            // Change City
            changeCity(value) {
                if(value){
                    if(typeof value != 'string'){
                        let city = this.comunities.find(item => {
                            return item.geonameId == value.geonameId})
                        this.data.city.label = city.label
                        this.data.city.value = city.value
                    }
                }else{
                    this.data.city.label = ''
                    this.data.city.value = ''
                }
            },
            changeSpecialty(value) {
                if(value){
                    if(typeof value != 'string'){
                        let specialty = this.specialities.find(item => {
                            return item.geonameId == value.geonameId})
                        this.data.specialty.label = specialty.label
                        this.data.specialty.value = specialty.value
                    }
                }else{
                    this.data.specialty.label = ''
                    this.data.specialty.value = ''
                }
            },
            changeHour(value) {
                if(value){
                    if(typeof value != 'string'){
                        let hour = this.hours.find(item => {
                            return item.value == value.value})
                        this.data.hour.label = hour.label
                        this.data.hour.value = hour.value
                    }
                }else{
                    this.data.hour.label = ''
                    this.data.hour.value = ''
                }
            },
            // Route login doctor
            redirectLogin(){
                this.$router.push({'name':'login.doctor'});
            },
            // Store doctor
            dump_box(){
                let self = this;
                 let box_data = {
                                    'box_schedule':{
                                        'lunes':  [self.radio1, self.radio8],
                                        'martes': [self.radio2, self.radio9],
                                        'miercoles': [self.radio3, self.radio10],
                                        'jueves' : [self.radio4, self.radio11],
                                        'viernes': [self.radio5, self.radio12],
                                        'sabado': [self.radio6, self.radio13],
                                        'domingo': [self.radio7, self.radio14]
                                    },
                                    'box_plan': self.data.box_plan,
                                    'box_speciality': self.data.specialty,
                                    'box_region': self.data.region,
                                    'box_city': self.data.city

                                }
                            let send_data= JSON.stringify(box_data);
                            console.log(send_data)
            },
            submit(scope){


            		console.log(this.process,"Procesando")

                var self = this;

                var error = false;
                if(this.doctor.code.length == 0)
                {
                    this.errors.code = "Rut es obligatorio";
                    error = true;
                }else{
                    this.errors.code = false;
                }
                if(this.doctor.email.length == 0)
                {
                    this.errors.email = "Email es obligatorio";
                    error = true;
                }else{
                    this.errors.email = false;
                }
                if(this.doctor.specialities.length == 0){
                    this.errors.specialities = "Debe seleccionar al menos una Especialidad";
                    error = true;
                } else {
                    this.errors.specialities = false;
                }
                this.$validator.validateAll(scope)
                    .then(function(result) {
                        // if(error){
                        //     return false;
                        // }
                        console.log("validating", result, self.errors)
                        // if(result || self.doctor.need_box){

                            self.process = true;
                            self.doctor.register_source = self.register_source;

                            var ruta;
                            if (self.update_massive) {
                              ruta = self.route.doctor.api.update_massive
                            } else {
                              ruta = self.route.doctor.api.register
                            }
                            let send_data = self.doctor;
                            if(self.doctor.need_box){
                                self.doctor.box_data = {
                                    'schedule':{
                                        'monday':  [self.radio1, self.radio8],
                                        'tuesday': [self.radio2, self.radio9],
                                        'wednesday': [self.radio3, self.radio10],
                                        'thursday' : [self.radio4, self.radio11],
                                        'friday': [self.radio5, self.radio12],
                                        'saturday': [self.radio6, self.radio13],
                                        'sunday': [self.radio7, self.radio14]
                                    },
                                    'period': self.data.box_plan.label.value,
                                    'speciality_id': self.data.specialty.value,
                                    'region_id': self.data.region.value,
                                    'city_id': self.data.city.value,
                                    'price': self.data.price
                                }
                            send_data.box_data;
                            }
                            self.$http.post(ruta, send_data)
                                .then(response => {
                                    self.process = false;
                                    if(response.data.status == "OK"){
                                        self.data.confirmation.isSuccess = true;
                                        self.data.confirmation.isError   = false;
                                        self.doctor.paid_code = response.data.data.paid_code;
                                    }else{
                                        self.data.confirmation.isSuccess = false;
                                        self.data.confirmation.isError   = true;
                                    }
                                    self.data.activeTab = 1;
                                }).catch(error => {
                                    self.process = false;
                                    if(error.response){
                                        if(error.response.status = 422){
                                            let data = error.response.data;
                                            // self.setErrors(error.response.data,self,scope);
                                        }else{
                                            console.log(error);
                                            alert("Error without message");
                                        }
                                    }else{
                                        console.log(error);
                                        alert("Error generic");
                                    }
                                });
                        // }
                    });
            },
            // Change code - Validate code
            changeCode: _.debounce(
                function () {
                    var validation = true
                    if(window.countryCODE == "cl"){
                        validation = validate_chile(this.doctor.code);
                    }
                    if(!validation){
                        this.errors['code'] = "RUT invalido"; //trabajar translate de esto
                        return;
                    }
                    this.$http.post(this.route.doctor.api.exists, { code: this.doctor.code,prefix: this.$route.params.country.toUpperCase() })
                        .then((response) => {
                        if (response.data.is_massive) {
                            // Hay doctor
                            console.log(response.data);
                            let doctor = response.data.doctor;
                            this.doctor.name = doctor.name;
                            this.doctor.lastname = doctor.lastname;
                            this.doctor.lastname2 = doctor.lastname2;
                            this.doctor.email = doctor.email;
                            this.doctor.phone = doctor.phone;
                            this.doctor.price = doctor.price;
                            this.doctor.paid_code = doctor.paid_code;
                            this.doctor.is_institution = doctor.is_institution;
                            this.doctor.specialities = doctor.specialities;
                            // check the specialities
                            this.$http.get('/specialities?country='+this.$route.params.country)
                            .then(response => {
                              if(response.data.status == "OK"){
                                this.specialities = response.data.data;
                                this.doctor.specialities.forEach( speciality => {
                                  this.specialities.find( _speciality  => {
                                    if (speciality.id == _speciality.id){
                                      _speciality.checked = true;
                                      return false;
                                    }
                                  });
                                });
                              }
                            });
                            this.update_massive = true;
                          }else{
                            this.update_massive = false;
                          }
                          this.errors.code = false;
                        }).catch(error => {
                            if(error.response){
                                if(error.response.status = 422){
                                    // this.setErrors(error.response.data, this, 'form-doctor');
                                }else{
                                    console.log(error);
                                    alert("Error without message");
                                }
                            }else{
                                console.log(error);
                                alert("Error generic");
                            }
                        });
                },
                500
            ),
            // Change email - Validate email
            changeEmail: _.debounce(
                function () {
                    this.$http.post(doctor.api.exists, { email: this.doctor.email })
                        .then((response) => {
                            this.errors.email = false;
                        }).catch(error => {
                            if(error.response){
                                if(error.response.status = 422){
                                    // this.setErrors(error.response.data, this, 'form-doctor');
                                }else{
                                    console.log(error);
                                    alert("Error without message");
                                }
                            }else{
                                console.log(error);
                                alert("Error generic");
                            }
                        });
                },
                500
            ),
            filterMedicineType(value){

                console.log(value);
                this.specialities = this.specialities.filter(specialty => {
                console.log(specialty.medicine_type);
                  return specialty.medicine_type == '1';
                })

            },
            // On chosen by speciality
            onChosen(add, speciality_id){
                if(add){
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = true;
                        }
                    });
                    this.doctor.specialities.push({"id": speciality_id});
                }else{
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = false;
                        }
                    });
                    this.doctor.specialities.find( (speciality, index) => {
                        if (speciality.id == speciality_id){
                            this.doctor.specialities.splice(index,1);
                            return false;
                        }
                    });
                }
            },
            // Set errors form
            setErrors: function(data,self,scope){
                for(let error in data)
                {
                    for(var index in data)
                    {
                        var messages = '';
                        data[index].forEach( function(item){ messages += item + ' '});
                        if(index == 'code' || index == 'email' || index == 'specialities')
                        {
                            self.errors[index] = messages;
                        }else{
                            self._errors.errors.unshift({
                                field: index,
                                msg: messages,
                                scope: scope
                            });
                        }
                    }
                }
            },
            // Update lang
            updateLang(lang){
                this.$store.dispatch('setLang', lang);
                this.$lang.setLanguage(lang);
            },
            // LoadLanguage
            ...mapActions({
                fetchLanguage: 'loadLanguage'
            }),
            // LoadLanguage from actions
            loadLanguage() {
                this.fetchLanguage();
            },
            // Get specialities by country
            getSpecialities(){
                let url = doctor.speciality.list + '?country=' + this.$route.params.country + '&lang=' + this.lang
                this.$http.get(url)
                    .then(response => {
                        if(response.data.status == "OK"){
                            let data = response.data.data;
                            data.map((item, index) => {
                                item.value = item.id;
                                item.label = item.name;
                                item.medicine_type = item.medicine_type;

                            });


                            this.specialities = data;
                        }
                    }).catch(error => {
                        console.error("error de espes");
                        console.log(error);
                    });
            }
        }
    }
</script>
<style>
.md-layout.container.md-input-container.masked_input .md-input.select2 {
    background: white;
}

button.clear {
    bottom: 5px !important;
}

.md-input-container > .select2 .open-indicator {
    top: 12px !important;
}
</style>

<style>

.medibox .md-layout.container.md-input-container.masked_input.md-input-invalid {
    padding-bottom: 0 !important;
    margin-bottom: 40px !important;
}

.medibox span.md-error {
    margin-left: 5px !important;
}

ul.schedule_days {
    list-style: none;
    padding: 0;
}

.marcaagua{
    font-size: 10px;
    color: gray;
}

ul.schedule_days label.md-checkbox-label {
    position: initial;
}
ul.schedule_days li {
    display: inline-block;
    min-width: 110px;
    padding: 10px;
    background: #d2e6e8;
    overflow: hidden;
}
ul.schedule_days li:nth-child(odd) {
    background: #dbe0e0;
}

@media (max-width: 700px) {
    ul.schedule_days li {
        width:100%;
    }
}
.bonus_container {
       margin-top:20px;
   }
.bonus_set {
    width: 33.33%;
    text-align: center;
    font-size: 20px;
    padding: 20px;
    float: left;
}
.bonus_set input {
    width: 100%;
    height: 30px;
    text-align:center
}

.bonus_set small {
    font-size: 10px;
    display: block;
}
.bonus_set:nth-child(3) {
    background-color: #f0efef;
}
.bonus_set:nth-child(4) {
    background-color: #e5e3e3b5;
}

@media (max-width:760px){
    .bonus_set {
    width: 100%;
    float: none !important;
    clear:both !important;
   }
   .bonus_container {
       height:auto !important;
       margin-top:20px;
   }
}
input.spin_input {-webkit-appearance: none;
    border: 1px solid #ebebeb;
    float: left;
    font-size: 16px;
    height: 40px !important;
    margin: 0;
    outline: none;
    text-align: center;
    width: calc(100% - 80px) !important;
}

button.spin_btn {
    -webkit-appearance: none;
    transition: background .5s ease;
    background: #f34b4b !important;
    border: 0;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    outline: none;
    width: 40px !important;
}
</style>
<style lang="stylus" scoped>
    @import '../../assets/styles/variables/color.styl'
    @import '../../assets/styles/boots.styl'

    /* LOGO
    ----------------------------------*/
    .register--wrap
        padding 50px 0
        .logo
            padding 0
            margin-bottom 5px

        .register-logo
            width: 75%
            max-width: 250px
            padding 0

        .section--title
            margin 24px 0
            font-size 2.4em
            padding-left 15px

    .register-panel
        position relative
        padding-bottom 20px
        box-shadow 0 3px 15px rgba(0,0,0,0.1) !important
        .register-steps
            clear both
            width 100%

        .register-first-step {width: 100%}

    .section--title
        color #2c4760
    .badge-title
        background-color color_form_placeholder
        font-size 12px
        font-weight 500

    .md-tab-header
        width 50%!important
        max-width initial!important
        background-color #f2f6fc!important
        color #2c4760!important
        border 1px solid #dcdfe6!important
    .md-tab-header-container
        text-align left!important
        align-items initial!important
        text-transform Capitalize!important
    .mt-tab
        height auto !important
        padding 3px 0
        background-color #f2f6fc
        color #2c4760
        border 1px solid rgba(0,0,0,0.1)
        height 48px
        line-height 50px
        font-weight 400
        text-shadow  0 1px 1px rgba(0,0,0,0.1)
        font-size 16px
        padding-left 20px
        background-clip border-box
    .mt-tab-active
        background-color #f34b4b
        color #ffffff
    .multiple
        border 1px solid color_form_border
        border-radius 5px
        width 100%
        .title
            margin 0.5em
            color color_form_placeholder
        .select
            overflow-y scroll
            overflow-x hidden
            margin 0.25em
            height 110px
            .option
                width 95%
                margin 0.25em
    .subtitle
        margin-top .5em
        color color_form_placeholder
    .mar-top-1
        margin-top 1em
    .mar-top-2
        margin-top 2em
    .language--box.language--register
        position absolute
        right 10px
        top 15px
        float right
        display block
        width auto
        span.language
            color #757e80
            float left
            margin-right 6px
            position relative
            top 4px
        .md-select
            min-width 0
            width auto
            float left
    .language--box.language--register:hover
        color color_form_value
    .row
        margin 0
        padding .5em
    .error
        color #ef5350
    @import '../../assets/styles/responsive.styl'
    .md-input-container
        margin-top 25px!important
</style>



// WEBPACK FOOTER //
// RegisterDoctor.vue?527fa9a0